import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import clsx from 'clsx';

import styles from './index.module.scss';

interface LoadingProps {
  size?: number;
  className?: string;
  absolute?: boolean;
  style?: React.CSSProperties;
}

function Loading({
  size: fontSize = 24,
  className = undefined,
  absolute = false,
  style,
}: LoadingProps) {
  const antIcon = <LoadingOutlined style={{ fontSize }} spin />;

  return (
    <div className={clsx(styles.loading, { [styles.absolute]: absolute }, className)} style={style}>
      <Spin indicator={antIcon} />
    </div>
  );
}

export default Loading;
